var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8801_44479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50.5C0 22.6096 22.6096 7.62939e-06 50.5 7.62939e-06C78.3904 7.62939e-06 101 22.6096 101 50.5C101 78.3904 78.3904 101 50.5 101C22.6096 101 0 78.3904 0 50.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8801_44479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1938 36.109C20.1352 35.416 19.5 34.25 19.5 33.0011V32.9979C19.5 30.79 21.3221 29 23.5696 29H76.5036C78.7511 29 80.5731 30.79 80.5731 32.9979V32.9999V33.0011C80.5731 34.25 79.9381 35.416 78.8794 36.109C73.7136 39.4931 58.148 49.6872 52.2953 53.5213C50.9273 54.4174 49.1459 54.4174 47.778 53.5213C41.9251 49.6872 26.3596 39.4931 21.1938 36.109Z",
    stroke: "#001B4D",
    strokeWidth: 4.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 33.0013V69.0019C19.5 70.0629 19.9285 71.0799 20.693 71.8299C21.4564 72.5809 22.4916 73.002 23.5715 73.002H76.5016C77.5815 73.002 78.6167 72.5809 79.3802 71.8299C80.1446 71.0799 80.5731 70.0629 80.5731 69.0019V33.0013",
    stroke: "#001B4D",
    strokeWidth: 4.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.e2d8bebfaac40004edf9ad48fc628459.svg";
export { ForwardRef as ReactComponent };